import { Header } from 'components/common/Accordion'
import theme from 'theme'

const SectionHeader = ({ ...rest }) => (
  <Header
    css={{
      display: 'grid',
      gridTemplateColumns: 'minmax(128px, 320px) 1fr',
      alignItems: 'center',
      gap: theme.space[3]
    }}
    {...rest}
  />
)

export default SectionHeader
